import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  realtimeDatabaseUrl: import.meta.env.VITE_FIREBASE_REALTIME_DATABASE_URL,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
};

// ----------------------------------------------------------------------

export const CONFIG = {
  appName: 'Khaya | Back-Office',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  mobileUrl: (() => {
    switch (import.meta.env.MODE) {
      case 'production':
        return 'https://wallet.jakrewardtechnology.com/';
      case 'trydev':
        return 'https://trydev.jakrewardtechnology.com/';
      default:
        return 'http://localhost:4201/';
    }
  })(),
};

export const PATH_AFTER_LOGIN = paths.dashboard.general.dashboardOverview;

export const TINY_CME_API_KEY = import.meta.env.VITE_TINY_MCE_API_KEY;
